(ns frontend.view.reports.custom.knight-2
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.db :as db]
   [frontend.view.reports.custom.events :as events]
   [ui.components.card.view :as card]
   [ui.editors.data-input :as data-input]))

(defn report-view
  [data]
  (let []
    [card/card
     [:div.card-container__header.d-flex.align-items-center.justify-content-between
      (if (:loading @db/deals-throughput)
        [:div.spinner-wrapper
         [:i.fal.fa-spinner.fa-pulse.fa-3x]]
        [:div.d-flex.justify-content-between.align-items-center
         {:key (:smallest-ts @db/deals-throughput)}
         [:span (loc/tr :deals-throughput)]

         [:div.d-flex.ml-3
          [:div.datepicker__wrapper.mr-3
           [:div.datepicker-wrapper
            [:label (loc/tr :from-date)]
            [data-input/view
             {:data-type :data.type/date
              :value     (or (:start-ts @db/deals-throughput)
                             0)
              :min-date  (some-> @db/deals-throughput
                                 :report
                                 :start-ts
                                 (js/Date.))
              :on-change (fn [new-value]
                           (swap! db/deals-throughput assoc :start-ts new-value))}]]]

          [:div.datepicker__wrapper
           [:div.datepicker-wrapper
            [:label (loc/tr :to-date)]
            [data-input/view
             {:data-type :data.type/date
              :value     (or (:end-ts @db/deals-throughput)
                             (.getTime (js/Date.)))
              :min-date  (some-> (:common/created-on @session/tenant)
                                 (js/Date.))
              :on-change (fn [new-value]
                           (swap! db/deals-throughput assoc :end-ts new-value))}]]]

          [:div.d-flex.justify-content-end
           [:div.zap-button.zap-button--primary-btn.mx-3
            {:on-click (fn [_]
                         (events/load-deals-throughput))}
            (loc/tr :create-report)]
           #_[:i.fal.fa-copy
              {:title    (loc/tr :copy-to-clipboard)
               :on-click (fn [_]
                           (clipboard/copy-as-tsv @export-atom))}]
           #_[:i.fal.fa-file-excel
              {:title    (loc/tr :save-as-excel)
               :on-click (fn [_]
                           (excel/export-array-data (loc/tr :export-filename-knight-2)
                                                    @export-atom))}]]]])]
     [:div.card-container__body
      (if (:loading @db/deals-throughput)
        [:div.d-flex.justify-content-center
         [:div.report-loading
          [:i.fal.fa-spinner.fa-pulse.fa-4x]]]
        [:table.zap-simple-table.zap-simple-table--sm.w-100
         [:thead
          [:tr
           [:th ""]
           [:th (loc/tr :count)]]]
         (doall (for [[report-key report-data] (:data data)]
                  [:tbody
                   {:key (str "stage-vs-tag-reports-row-2" report-key)}
                   [:tr
                    [:td.col-heading
                     (loc/tr report-key)]
                    [:td.row-total-deals.number-value
                     (count report-data)]]
                   (doall (for [stage (->> @session/all-stages
                                           (remove :common/disabled?)
                                           (sort-by :common/ord))]
                            (let [stage-id (:db/id stage)]
                              [:tr
                               {:key (str "report-deals-throughput-" report-key "-" stage-id)}
                               [:td (entity/display-string stage)]
                               [:td
                                (->> report-data
                                     (filter (fn [[oppo-id oppo-data]]
                                               (some #{stage-id} (:stage-ids oppo-data))))
                                     (count))]])))]))])]]))

(defn view
  [_]
  (swap! db/deals-throughput
         assoc
         :loading false
         :start-ts (- (.getTime (js/Date.)) (* 365 24 3600 1000))
         :end-ts (.getTime (js/Date.)))
  (fn [_]
    (let [data (:report @db/deals-throughput)]
      [:div
       [report-view data]])))
